import axios from 'axios';
import router from '@/router';
import * as authUtils from '@/util/auth';
import * as lib from '@/util/lib.js';
import {frontLogout, getRefreshToken} from '@/api/login';
import translate from '@/util/errorCode';
import Notify from '@/plugins/notify';
import {getLanguageStr} from './language';
import {getIn} from './manipulate';
let pending = [];
let removePending = (config, f) => {
	// let flagUrl = config.url + '&' + config.method
	// console.log(config);
	let flagUrl;
	if (config.params != undefined) {
		flagUrl = config.url + '&' + config.method + '&' + JSON.stringify(config.params);
	} else {
		flagUrl = config.url + '&' + config.method + '&' + JSON.stringify(config.data);
	}

	if (pending.indexOf(flagUrl) !== -1) {
		if (f) {
			f(); // 执行取消操作
		} else {
			pending.splice(pending.indexOf(flagUrl), 1); // 把这条记录从数组中移除
		}
	} else {
		if (f) {
			pending.push(flagUrl);
		}
	}
};

// 创建axios实例
const service = axios.create({
	// timeout: 15000,
	// headers: {
	// 	'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
	// }
});

service.interceptors.request.use(config => {
	lib.updateToDo('api');
	// if (config.method === 'post') {
	// 	//请求序列化，用qs转化，类似ajax data  formdata 传输，axios 默认是json
	// 	config.data = qs.stringify(config.data);
	// }
	// config.cancelToken = new CancelToken((c) => {
	// 	removePending(config, c)
	// })
	if (config.method === 'formdata') {
		config.method = 'post';
		config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
	}
	// else if(config.method=="upload"){
	// 	config.headers['Content-Type']="multipart/form-data"
	// 	config.method="post";
	// }
	if ($.type(config.data) == 'string') { // 文本传参直传
		config.headers['Content-Type'] = 'text/html';
	}

	let token = authUtils.getToken();
	if (token != null) {
		config.headers['Authorization'] = `Bearer ${token}`;
	}
	return config;
}, error => {
	return Promise.reject(error);
});

// response拦截器
service.interceptors.response.use(
	response => {
		// removePending(response.config)
		// console.log(response);
		let headers = response.headers['content-type'] || '';
		if (stage.loc.loginSystem.um && headers.indexOf('html') >= 0) {
			trace('UM下收到html头的返回数据');
			location.href = '/login';// um系统下，返回类型为html的情况就是他们报错了，货到登录
		} else return Promise.resolve(response.data);
	},
	error => {
		console.log(error.message);
		// console.log(error.response)
		// 首席按判断返回类型是否是blob类型
		try {
			if (!error.message) {
				return Promise.reject('');
			}
			if (error.response.request.responseType == 'blob') {
				let blob = new Blob([error.response.data], {type: 'application/json'});
				var fr = new FileReader();
				// 读取blob数据
				fr.onload = e => {
					// 解析blob数据为JSON
					error.response.data = JSON.parse(e.target.result);
					// 处理错误码权限弹窗等问题
					return reponseFactroy(error);
				};
				fr.readAsText(blob);
				// 必须执行 返回错误 让前置查询可以在catch中捕获
				return Promise.reject('');
			} else {
				return Promise.reject(reponseFactroy(error));
			}
		} catch (e) {
			return Notify.init(getLanguageStr('task77', '当前网络不佳，请稍后重试'));
		}
		return Promise.reject('');
	}
);
function reponseFactroy (error) {
	pending = [];
	var error = Object.assign({}, error);
	// console.log(error.response)
	let {status} = error.response || {status: -1};
	// 第一次是access_token 调取
	if (error.response.headers['content-type'] != 'text/html' && !error.response.data.code) {
		try {
			error.response.data.code = error.response.data.message || '';// 有时候报错在message里
		} catch (e) {
			console.log(e);
		}
	}
	if (status === -1) {
		trace('没有返回任何数据');
	} else if (status === 401) {
		console.log('access_token 调取失败');
		if (error.response.data.error == 'solarman_token_invalid') {
			Notify.init(translate('solarman_token_invalid'));
			router.push({path: '/login'});
		}
		// 失败的话重新用refresh_token 刷新 access_token
		if (authUtils.getRefreshToken()) {
			getRefreshToken('/oauth/token', {
				grant_type: 'refresh_token',
				client_id: 'test',
				refresh_token: authUtils.getRefreshToken()
			}).then(response => {
				let {access_token, refresh_token} = response;
				authUtils.setToken(access_token);
				authUtils.setRefreshToken(refresh_token);

				// 拿取新的accessToken 登录 刷新一下
				setTimeout(() => {
					location.reload();
				}, 50);
			}, error => {
				console.log('error: ' + error);
				// 重新登录
				frontLogout().then(() => {
					// location.reload();
					// this.$router.push("/login");
					router.push({path: '/login'});
				});
			});
		} else { // 没有刷新token直接注销
			frontLogout().then(() => {
				router.push({path: '/login'});
			});
		}
	} else if (status === 403) {
		Notify.init(translate(error.response.data.code));
		return translate('AU_NO_OPERATION_PERMISSION');
	} else if (status == 301) {
		// this.$router.push("/login");
		trace('301');
		router.push({path: '/login'});
	} else if (status == 500) {
		// Notify.init(translate(error.response.data.code));
		return translate(error.response.data.code);
	} else if (status == 502) {
		// Notify.init(translate('sorry_for_server_exception'));
		return translate('sorry_for_server_exception');
	} else if (status == 405) {
		// Notify.init(translate('sorry_for_server_exception'));
		return translate('sorry_for_server_exception');
	} else if (status == 429) {
		return translate('REQUEST_TOO_FREQUENTLY');
	} else {
		if (error.response && error.response.data && error.response.data.code) {
			const codeList = ['FILE_TYPE_NOT_SUPPORTED', 'SN_MAX_LIMIT', 'CONTENT_FORMAT_INCORRECT', 'X_Y_CANNOT_NULL', 'X_Y_REPEAT', 'GROUP_INDEX_OR_GROUP_NUMBER_IS_NULL', 'GROUP_INDEX_GROUP_NUMBER_REPEAT', 'LAYOUT_CANNOT_INTEGER', 'SN_REPEAT', 'SN_INVALID', 'GROUP_INDEX_GROUP_NUMBER_NOT_CONTINUOUS', 'ACC_ORG_AREA_NOT_MATCH_CURRENT_CENTER', 'STATION_AREA_NOT_MATCH_CURRENT_CENTER'];
			if (codeList.includes(error.response.data.code)) {
				return translate(error.response.data.code);
			}
		}
		// trace(error.response,false,true);
		if (error.response && error.response.data && error.response.data.code) {
			// 业务层 412 错误逻辑  国际化{"code":"xx","param":xx}
			let code = getIn(error.response, ['data', 'code']);

			// excludeList将不展示弹框
			if (code) {
				const excludeList = [
					'STATION_NEED_AUTH'
				];
				if (!excludeList.includes(code)) {
				// 412
					Notify.init(translate(code));
					return translate(code);
				} else {
					// 获取错误详细信息，不以弹框形式
					let str = error.response.data;
					if (!_.isEmpty(str)) {
						return error.response;
					// return translate(str.code || 'sorry_for_server_exception');
					}
				}
			} else {
				Notify.init(translate(error.response.data.code));
			}
		} else {
			// Notify.init(translate('sorry_for_server_exception'));
		};
	}
}

export default service;



// WEBPACK FOOTER //
// ./src/util/request.js